
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"151","height":"53","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.533 15.02L4 34.414l.336 8.99 5.559 1.93 7.051-8.682 6.568-15.484m7.78 4.034l-2.866 16.537.819 6.858L46.445 49M32.523 38.513l13.103-1.21m-12.284-9.681h8.19l6.96-1.21m24.161 0l-10.647-2.017-7.37.807v10.084l16.38 2.017 2.866 6.453L62.825 49l-9.418-5.244m44.635-25.412l-12.285.807-6.142 4.437 1.228 6.05 17.199-.806 4.914 8.47-8.19 2.824-14.333-.403m22.523-28.236l4.504 14.925 6.961 8.874 15.561-4.84m-19.656-7.665l13.514-1.613m-18.837-9.68l20.065-1.21M129.982 1l1.638 17.345 4.095 11.294h10.647l1.638-8.47","stroke":"#fff","stroke-width":"6"}})])
          )
        }
      }
    